/**
 * Homepage-critical translation keys only.
 * Full translations are lazy-loaded from i18n-data.ts.
 */
export const coreTranslations: Record<string, Record<string, string>> = {
  // Navigation
  "nav.home": { tr: "Ana Sayfa", en: "Home", ru: "Главная" },
  "nav.explore": { tr: "Keşfet", en: "Explore", ru: "Обзор" },
  "nav.map": { tr: "Harita", en: "Map", ru: "Карта" },
  "nav.trend": { tr: "Trend", en: "Trending", ru: "Тренды" },
  "nav.login": { tr: "Giriş Yap", en: "Sign In", ru: "Войти" },
  "nav.logout": { tr: "Çıkış Yap", en: "Sign Out", ru: "Выйти" },
  "nav.panel": { tr: "Panel", en: "Dashboard", ru: "Панель" },
  "nav.event": { tr: "Etkinlik", en: "Event", ru: "Событие" },
  "nav.favorites": { tr: "Favori", en: "Favorites", ru: "Избранное" },
  "nav.tickets": { tr: "Biletlerim", en: "My Tickets", ru: "Мои билеты" },
  "nav.profile": { tr: "Profil", en: "Profile", ru: "Профиль" },
  "nav.menu": { tr: "Menü", en: "Menu", ru: "Меню" },
  // Hero
  "hero.title1": { tr: "Unutulmaz Anlar", en: "Unforgettable Moments", ru: "Незабываемые моменты" },
  "hero.title2": { tr: "Burada Başlar", en: "Start Here", ru: "Начинаются здесь" },
  "hero.subtitle": { tr: "Konserler, festivaller, tiyatrolar ve daha fazlası. Şehrindeki en iyi etkinlikleri keşfet.", en: "Concerts, festivals, theatres and more. Discover the best events in your city.", ru: "Концерты, фестивали, театры и многое другое. Откройте лучшие события в вашем городе." },
  "hero.searchPlaceholder": { tr: "Ne arıyorsun?", en: "What are you looking for?", ru: "Что вы ищете?" },
  "hero.discover": { tr: "Keşfet", en: "Discover", ru: "Открыть" },
  "hero.soldTickets": { tr: "Satılan Bilet", en: "Tickets Sold", ru: "Продано билетов" },
  "hero.events": { tr: "Etkinlik", en: "Events", ru: "Событий" },
  "hero.organizers": { tr: "Organizatör", en: "Organizers", ru: "Организаторов" },
  // Categories
  "cat.title": { tr: "Kategoriler", en: "Categories", ru: "Категории" },
  "cat.subtitle": { tr: "İlgi alanına göre etkinlik bul", en: "Find events by interest", ru: "Найдите события по интересам" },
  "cat.concert": { tr: "Konser", en: "Concert", ru: "Концерт" },
  "cat.festival": { tr: "Festival", en: "Festival", ru: "Фестиваль" },
  "cat.theatre": { tr: "Tiyatro", en: "Theatre", ru: "Театр" },
  "cat.standup": { tr: "Stand-Up", en: "Stand-Up", ru: "Стендап" },
  "cat.art": { tr: "Sanat", en: "Art", ru: "Искусство" },
  "cat.outdoor": { tr: "Outdoor", en: "Outdoor", ru: "На природе" },
  "cat.camp": { tr: "Kamp", en: "Camping", ru: "Кемпинг" },
  "cat.tech": { tr: "Tech", en: "Tech", ru: "Технологии" },
  "cat.cinema": { tr: "Sinema", en: "Cinema", ru: "Кино" },
  // HomeSections
  "home.loading": { tr: "Etkinlikler yükleniyor...", en: "Loading events...", ru: "Загрузка событий..." },
  "home.noEvents": { tr: "Henüz aktif etkinlik bulunmuyor", en: "No active events yet", ru: "Пока нет активных событий" },
  "home.trending": { tr: "Trend Etkinlikler", en: "Trending Events", ru: "Тренды" },
  "home.trendingSub": { tr: "En çok görüntülenen etkinlikler", en: "Most viewed events", ru: "Самые просматриваемые" },
  "home.popular": { tr: "Popüler Etkinlikler", en: "Popular Events", ru: "Популярные" },
  "home.popularSub": { tr: "Herkesin favorisi", en: "Everyone's favorite", ru: "Фавориты всех" },
  "home.activitiesTitle": { tr: "Popüler Aktiviteler", en: "Popular Activities", ru: "Популярные активности" },
  "home.activitiesSub": { tr: "Macera dolu aktiviteler ve etkinlikler", en: "Adventure-filled activities and events", ru: "Активности и события, полные приключений" },
  "common.seeAll": { tr: "Tümünü Gör", en: "See All", ru: "Смотреть все" },
  "home.oneplus": { tr: "1+1 Biletler", en: "1+1 Tickets", ru: "Билеты 1+1" },
  "home.oneplusSub": { tr: "İki bilet al, bir fiyat öde!", en: "Buy two, pay for one!", ru: "Купи два, заплати за один!" },
  "home.youth": { tr: "Gençlere Özel", en: "Youth Special", ru: "Для молодёжи" },
  "home.youthSub": { tr: "Öğrenci dostu fiyatlar", en: "Student-friendly prices", ru: "Студенческие цены" },
  "home.music": { tr: "Müzik", en: "Music", ru: "Музыка" },
  "home.musicSub": { tr: "Ritmini bul", en: "Find your rhythm", ru: "Найди свой ритм" },
  "home.weekend": { tr: "Haftasonu", en: "Weekend", ru: "Выходные" },
  "home.weekendSub": { tr: "Hafta sonu planını yap", en: "Plan your weekend", ru: "Спланируй выходные" },
  "home.concerts": { tr: "Konserler", en: "Concerts", ru: "Концерты" },
  "home.concertsSub": { tr: "Canlı müzik deneyimi", en: "Live music experience", ru: "Живая музыка" },
  "home.festivals": { tr: "Festivaller", en: "Festivals", ru: "Фестивали" },
  "home.festivalsSub": { tr: "Büyük sahne, büyük heyecan", en: "Big stage, big excitement", ru: "Большая сцена, большие эмоции" },
  "home.theatre": { tr: "Tiyatro", en: "Theatre", ru: "Театр" },
  "home.theatreSub": { tr: "Sahne sanatları", en: "Performing arts", ru: "Сценическое искусство" },
  "home.standup": { tr: "Stand-Up", en: "Stand-Up", ru: "Стендап" },
  "home.standupSub": { tr: "Kahkaha garantili geceler", en: "Guaranteed laughs", ru: "Гарантированный смех" },
  "home.camp": { tr: "Kamp", en: "Camping", ru: "Кемпинг" },
  "home.campSub": { tr: "Doğayla buluş", en: "Meet nature", ru: "Встреча с природой" },
  "home.workshop": { tr: "Workshop", en: "Workshop", ru: "Мастер-класс" },
  "home.workshopSub": { tr: "Öğren, geliş, keşfet", en: "Learn, grow, discover", ru: "Учись, развивайся, открывай" },
  "home.featured": { tr: "Öne Çıkan", en: "Featured", ru: "Рекомендуемое" },
  // Group ticket banner
  "group.title": { tr: "Grup Bileti ile %20 İndirim!", en: "20% Off with Group Tickets!", ru: "Скидка 20% на групповые билеты!" },
  "group.subtitle": { tr: "5+ bilet al, arkadaşlarınla birlikte gel", en: "Buy 5+ tickets, come with friends", ru: "Купите 5+ билетов, приходите с друзьями" },
  "group.cta": { tr: "Grup Bileti Al", en: "Get Group Tickets", ru: "Купить групповой билет" },
  // Common basics
  "common.search": { tr: "Etkinlik, sanatçı veya mekan ara...", en: "Search events, artists or venues...", ru: "Поиск событий, артистов или мест..." },
  "common.buy": { tr: "Satın Al", en: "Buy Now", ru: "Купить" },
  "common.soldOut": { tr: "Tükendi", en: "Sold Out", ru: "Распродано" },
  "common.free": { tr: "Ücretsiz", en: "Free", ru: "Бесплатно" },
  "common.loading": { tr: "Yükleniyor...", en: "Loading...", ru: "Загрузка..." },
  "card.sold": { tr: "satıldı", en: "sold", ru: "продано" },
  "card.left": { tr: "kaldı", en: "left", ru: "осталось" },
  "card.buyTicket": { tr: "Bilet Al", en: "Buy Ticket", ru: "Купить" },
  "card.free": { tr: "Ücretsiz", en: "Free", ru: "Бесплатно" },
  // Footer
  "footer.tagline": { tr: "Etkinliklerin yeni adresi.", en: "Where events come alive.", ru: "Платформа событий нового поколения." },
  "footer.explore": { tr: "Keşfet", en: "Explore", ru: "Обзор" },
  "footer.trendingEvents": { tr: "Trend Etkinlikler", en: "Trending Events", ru: "Тренды" },
  "footer.nearby": { tr: "Yakındaki", en: "Nearby", ru: "Рядом" },
  "footer.categories": { tr: "Kategoriler", en: "Categories", ru: "Категории" },
  "footer.map": { tr: "Harita", en: "Map", ru: "Карта" },
  "footer.info": { tr: "Bilgi", en: "Info", ru: "Информация" },
  "footer.faq": { tr: "SSS", en: "FAQ", ru: "FAQ" },
  "footer.about": { tr: "Hakkımızda", en: "About Us", ru: "О нас" },
  "footer.refund": { tr: "İade Politikası", en: "Refund Policy", ru: "Возврат" },
  "footer.privacy": { tr: "Gizlilik", en: "Privacy", ru: "Конфиденциальность" },
  "footer.terms": { tr: "Koşullar", en: "Terms", ru: "Условия" },
  "footer.contact": { tr: "İletişim", en: "Contact", ru: "Контакты" },
  "footer.copyright": { tr: "Tüm hakları saklıdır.", en: "All rights reserved.", ru: "Все права защищены." },
};
